import get from 'lodash.get';

const getCustomColorSchemeTemplate = (state) =>
  get(state, 'ws.template.meta.customization.customColorSchemeTemplate', '');

export default getCustomColorSchemeTemplate;
